import { DSNCEngagementStarter } from 'shared-definitions/types'
import { ApiComponentFeaturedComment } from '../types.wp'

export function ncEngagementStarter(input: ApiComponentFeaturedComment): DSNCEngagementStarter {
  return {
    resource: 'nc-engagement-starter',
    containerId: input.engagement_container_id,
  }
}
